import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { axiosInstance } from "../../AxiosInterceptor/axiosInterceptor";

const initialState = {
    runDate: [],
    carrier: [],
    seqNo: [],
    searchTriggered: true,
    loading: true,
    error: false
}

export const getRunDate = createAsyncThunk('data/getRunDate', async (tab, { rejectWithValue }) => {
    try {
        let params = `query{
        
            GetRunDate(tabname:"${tab}"){
            data{
             
              RunDate
    
            }
            }
          }`
        const response = await axiosInstance.post(process.env.REACT_APP_RUNID_DETAIL, {
            query: params
        });
        return response.data.data.GetRunDate.data;
    }
    catch (error) {
        return rejectWithValue(error.message || 'Unexpected error');
    }

});

export const getRunDateSeqNo = createAsyncThunk('data/getRunDateSeqNo', async (param, { rejectWithValue }) => {
    try {
        let params = `query{
            
            GetRunId(runid:"${param.runId}",tabname:"${param.tab}"){
            data{
              
              SequenceNumber
            }
            }
          }`
        const response = await axiosInstance.post(process.env.REACT_APP_RUNID_DETAIL, {
            query: params
        });
        return response.data.data.GetRunId.data;
    }
    catch (error) {
        return rejectWithValue(error.message || 'Unexpected error');
    }
});

export const getCarrier = createAsyncThunk('data/getCarrier', async (param, { rejectWithValue }) => {
    try {
        let params = `query{
            GetCarrier(runid:"${param.runId}",seq: "${param.seq}",tabname:"${param.tab}") {
    
              data{
                carrier
              }
            }
          }`
        const response = await axiosInstance.post(process.env.REACT_APP_CARRIER_DETAIL, {
            query: params
        });
        return response.data.data.GetCarrier.data;
    }
    catch (error) {
        return rejectWithValue(error.message || 'Unexpected error');
    }

});

const cnsCommonSlice = createSlice({
    name: 'cnsCommon',
    initialState,
    reducers: {
        clearAll: (state, action) => {
            state.runDate = [];
            state.seqNo = [];
            state.carrier = [];
            state.loading = true;
        },
        clearRunIdAndSubq: (state, action) => {
            state.seqNo = [];
            state.carrier = [];
            state.loading = true;
        },
        clearSeqAndSubq: (state, action) => {
            state.carrier = [];
            state.loading = true;
        },
        searchTriggered: (state, action) => {
            state.searchTriggered = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getRunDate.pending, (state) => {
                state.loading = true;
                state.error = false;
            })
            .addCase(getRunDate.fulfilled, (state, action) => {
                state.error = false;
                state.loading = false;
                state.runDate = Array.from(
                    new Set(action.payload.map((row) => row.RunDate))
                );
            })
            .addCase(getRunDate.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
            })
            .addCase(getRunDateSeqNo.pending, (state) => {
                state.loading = true;
                state.error = false;
            })
            .addCase(getRunDateSeqNo.fulfilled, (state, action) => {
                state.error = false;
                state.loading = false;
                state.seqNo = Array.from(
                    new Set(action.payload.map((row) => row.SequenceNumber))
                );
            })
            .addCase(getRunDateSeqNo.rejected, (state, action) => {
                state.loading = false;
                state.error = false;
            })
            .addCase(getCarrier.pending, (state) => {
                state.loading = true;
                state.error = false;
            })
            .addCase(getCarrier.fulfilled, (state, action) => {
                state.error = false;
                state.loading = false;
                state.carrier = action.payload.length > 0 ? Array.from(
                    new Set(action.payload.map((row) => row.carrier))) : []

            })
            .addCase(getCarrier.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
            });
    },


})

export const { clearRunIdAndSubq, clearSeqAndSubq, searchTriggered, clearAll } = cnsCommonSlice.actions;
export default cnsCommonSlice.reducer;